module.exports = __webpack_public_path__ + "img/sol_cap1.d74c4bbd.png";